import { Box } from '@chakra-ui/react'

export const AddressSearchError = () => {
  return (
    <Box color='red.500' fontSize='14px' mt='8px'>
      A valid street address is required
    </Box>
  )
}
